/* ============================================================
   KORE Motion — motor de interacción (v5 · Emil-grade)

   - Reveal de títulos (clip-wipe + blur→foco) y eyebrows (wipe H)
   - CTAs magnéticas con muelle + feedback de pulsación scale(.96)
   - Barrido de luz sobre imágenes al entrar ("cabezal de impresión")

   Principios: transform/opacity/clip-path (GPU), curvas fuertes,
   hover gateado a puntero fino, respeto a prefers-reduced-motion.
   Progresivo: sin JS el contenido queda visible y usable.
   ============================================================ */
(function () {
  'use strict';
  if (window.KoreMotion) return;
  window.KoreMotion = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Títulos de sección de todo el front */
  /* Los dos títulos de "Crea tu colección" (.kcc__title del acto 01 y
     .kcc__h3 del acto 02) sustituyen a .kfw__title, .kcb__title y
     .kfw-lead__title: eran los de "Para colectivos" y "Catálogo", las
     dos secciones que se fundieron en ella. */
  var TITLES = [
    '.kpv__title', '.kwd__title', '.kcc__title', '.kfc__title',
    '.khw__title', '.kb__title', '.kcl__title', '.kcx__title',
    '.kpc__title', '.kps__title', '.kpt__title', '.krp__title',
    '.pcf__title', '.pco__title', '.pfq__title', '.ptp__title',
    '.kpr__title', '.kww__title', '.kfq__title', '.kcc__h3',
    '.kth__title', '.kth__hero-title', '.kop__title'
  ].join(',');

  var EYEBROWS = [
    '.kpv__eyebrow', '.kwd__eyebrow', '.kfw__eyebrow', '.kfc__eyebrow',
    '.khw__eyebrow', '.kb__eyebrow', '.kcl__eyebrow', '.kcx__eyebrow',
    '.kpc__eyebrow', '.kps__eyebrow', '.kpt__eyebrow',
    '.kpr__eyebrow', '.kww__eyebrow', '.kfq__eyebrow', '.kcb__eyebrow',
    '.kth__eyebrow', '.kop__eyebrow'
  ].join(',');

  /* CTAs principales → magnéticas. Las variantes secundarias (ghost, perla)
     quedan fuera: el imán señala la acción principal, no cualquier botón. */
  var MAGNETIC = [
    '.kore-cta:not(.kore-cta--ghost):not(.kore-cta--pearl)', '.kfc__btn-primary',
    '.pco__btn-primary', '.pfq__btn-primary', '.ptp__btn-primary', '.pcf__btn-primary'
  ].join(',');

  /* Todas las CTAs → feedback de pulsación */
  var PRESSABLE = [
    '.kore-cta', '.kfc__btn-primary', '.kfc__btn-ghost', '.pco__btn-primary',
    '.pfq__btn-primary', '.ptp__btn-primary', '.ptp__btn-ghost',
    '.pcf__btn-primary', '.pcf__btn-ghost', '.kcl__btn', '.kcx__btn',
    '.khw__btn', '.kpc__btn', '.kps__btn', '.ptp__btn'
  ].join(',');

  /* Bloques de imagen que reciben el barrido de luz */
  var MEDIA = [
    '.kwd__frame', '.kfw__img', '.kcl__media',
    '.kcx__media', '.krp__media'
  ].join(',');

  function each(sel, root, fn) {
    var nodes = (root || document).querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }

  /* ── Disparo por scroll con getBoundingClientRect ──
     No usamos IntersectionObserver: no dispara de forma fiable para
     elementos dentro del stage anclado (position:sticky + overflow:hidden)
     del motor de pin, y en escritorio el scroll ocurre en .page-wrapper,
     no en window. getBoundingClientRect() sí da la posición real del
     elemento pese a esos ancestros; es el mismo patrón que kore-scrolly. */
  var pendingRv = [];   // títulos/eyebrows armados esperando entrar
  var pendingScan = []; // bloques de imagen esperando el barrido
  var rafCheck = 0;

  function runCheck() {
    rafCheck = 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    for (var i = pendingRv.length - 1; i >= 0; i--) {
      var el = pendingRv[i];
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh * 0.9) {
        el.classList.add('kore-rv--in');
        pendingRv.splice(i, 1);
      }
    }
    for (var k = pendingScan.length - 1; k >= 0; k--) {
      var b = pendingScan[k];
      var rb = b.getBoundingClientRect();
      if (rb.bottom > 0 && rb.top < vh * 0.72) {
        playScan(b);
        pendingScan.splice(k, 1);
      }
    }
  }

  function scheduleCheck() {
    if (!rafCheck && (pendingRv.length || pendingScan.length)) {
      rafCheck = requestAnimationFrame(runCheck);
    }
  }

  /* ── Reveal de títulos y eyebrows ──
     Lo ya visible al cargar aparece en estado final (sin parpadeo);
     el resto anima al entrar por scroll. ── */
  function initReveal(root) {
    if (reduce.matches) return;
    function arm(el, cls) {
      if (el.dataset.koreRv) return;
      el.dataset.koreRv = '1';
      el.classList.add(cls);
      pendingRv.push(el);
    }
    each(TITLES, root, function (el) { arm(el, 'kore-rv'); });
    each(EYEBROWS, root, function (el) { arm(el, 'kore-rv-x'); });
    runCheck(); // revela de inmediato lo que ya está en pantalla
  }

  /* ── Barrido de luz sobre imágenes ("cabezal de impresión") ── */
  function initScan(root) {
    if (reduce.matches) return;
    each(MEDIA, root, function (block) {
      if (block.dataset.koreScan) return;
      block.dataset.koreScan = '1';
      pendingScan.push(block);
    });
    runCheck();
  }

  function playScan(block) {
    try {
      if (getComputedStyle(block).position === 'static') {
        block.style.position = 'relative';
      }
      var scan = document.createElement('div');
      scan.className = 'kore-scan';
      var bar = document.createElement('div');
      bar.className = 'kore-scan__bar';
      scan.appendChild(bar);
      block.appendChild(scan);

      var anim = bar.animate(
        [
          { transform: 'translateY(-140%)' },
          { transform: 'translateY(430%)' }
        ],
        { duration: 1100, easing: 'cubic-bezier(0.5, 0, 0.2, 1)', fill: 'forwards' }
      );
      anim.onfinish = function () { if (scan.parentNode) scan.parentNode.removeChild(scan); };
    } catch (err) { /* noop */ }
  }

  /* ── Reveal .kore-anim (global) ──
     Observer único para todas las secciones sin copia inline del
     script legacy. Idempotente por elemento (dataset), así convive
     sin conflicto con las copias embebidas que aún quedan en las
     páginas antiguas (doble is-visible = no-op). ── */
  var animObs = null;
  function initAnim(root) {
    if (!animObs) {
      animObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            animObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    }
    each('.kore-anim', root, function (el) {
      if (el.dataset.koreAnimObs || el.classList.contains('is-visible')) return;
      el.dataset.koreAnimObs = '1';
      animObs.observe(el);
    });
  }

  /* ── Feedback de pulsación en CTAs ── */
  function initPress(root) {
    each(PRESSABLE, root, function (el) {
      if (el.dataset.korePress) return;
      el.dataset.korePress = '1';
      el.classList.add('kore-pressable');
    });
  }

  /* ── CTAs magnéticas con muelle (decorativo, solo puntero fino) ── */
  function initMagnetic(root) {
    if (reduce.matches || !finePointer.matches) return;

    each(MAGNETIC, root, function (el) {
      if (el.dataset.koreMag) return;
      el.dataset.koreMag = '1';
      el.classList.remove('kore-pressable'); // el JS gestiona su transform
      el.classList.add('kore-magnetic');

      var tx = 0, ty = 0, cx = 0, cy = 0; // actual / objetivo
      var press = 1, pressTarget = 1;
      var raf = null, hovering = false;
      var STRENGTH = 0.28, MAX = 14;

      function loop() {
        cx += (tx - cx) * 0.16;
        cy += (ty - cy) * 0.16;
        press += (pressTarget - press) * 0.22;
        el.style.transform = 'translate(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px) scale(' + press.toFixed(3) + ')';
        var settled = Math.abs(tx - cx) < 0.1 && Math.abs(ty - cy) < 0.1 && Math.abs(pressTarget - press) < 0.002;
        if (settled && !hovering && pressTarget === 1) {
          el.style.transform = '';
          el.classList.remove('kore-magnetic--active');
          raf = null;
          return;
        }
        raf = requestAnimationFrame(loop);
      }
      function kick() {
        el.classList.add('kore-magnetic--active');
        if (!raf) raf = requestAnimationFrame(loop);
      }

      el.addEventListener('pointermove', function (ev) {
        if (ev.pointerType && ev.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2);
        var dy = ev.clientY - (r.top + r.height / 2);
        tx = Math.max(-MAX, Math.min(MAX, dx * STRENGTH));
        ty = Math.max(-MAX, Math.min(MAX, dy * STRENGTH));
        hovering = true;
        kick();
      });
      el.addEventListener('pointerenter', function () { hovering = true; });
      el.addEventListener('pointerleave', function () {
        hovering = false; tx = 0; ty = 0; kick();
      });
      el.addEventListener('pointerdown', function () { pressTarget = 0.96; kick(); });
      window.addEventListener('pointerup', function () { pressTarget = 1; kick(); });
    });
  }

  /* ── Brillo especular que sigue al puntero sobre paneles de vidrio ──
     Decorativo → solo puntero fino + no-reduced. Actualiza --gx/--gy. ── */
  function initGlass(root) {
    if (reduce.matches || !finePointer.matches) return;
    each('.kore-glass', root, function (el) {
      if (el.dataset.koreGlass) return;
      el.dataset.koreGlass = '1';
      el.classList.add('kore-glass--live');
      var ticking = false, lx = 50, ly = 0;
      el.addEventListener('pointermove', function (ev) {
        if (ev.pointerType && ev.pointerType !== 'mouse') return;
        var r = el.getBoundingClientRect();
        lx = ((ev.clientX - r.left) / r.width) * 100;
        ly = ((ev.clientY - r.top) / r.height) * 100;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            el.style.setProperty('--gx', lx.toFixed(1) + '%');
            el.style.setProperty('--gy', ly.toFixed(1) + '%');
            ticking = false;
          });
        }
      });
    });
  }

  function init(root) {
    try { initAnim(root); } catch (e) {}
    try { initReveal(root); } catch (e) {}
    try { initScan(root); } catch (e) {}
    try { initPress(root); } catch (e) {}
    try { initMagnetic(root); } catch (e) {}
    try { initGlass(root); } catch (e) {}
  }

  /* Escucha el scroll en captura: el tema desplaza .page-wrapper (no window)
     en escritorio, así que solo así recogemos el scroll del contenedor real.
     El pin reordena el layout en 'load', por eso reevaluamos ahí también. */
  document.addEventListener('scroll', scheduleCheck, { capture: true, passive: true });
  window.addEventListener('resize', scheduleCheck);
  window.addEventListener('load', function () { runCheck(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  /* Reinyección en el editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
